import React from 'react';

import { ResponsiveDrawerInterface } from '@components/views/components/listing/drawer/ResponsiveSearchDrawerItem';
import SelectedComponent from '@shared/searchBar/datePicker/selectedComponent';
import EmptyComp from '@shared/searchBar/datePicker/emptyComp';
import { formatDateForDateInput } from '@utils/dateUtil';

import { ResponsiveSearchDrawerItemContent } from './styled';

const HotelResponsiveSearchDrawerItem: React.FC<ResponsiveDrawerInterface> = ({
  onClick = () => false,
  startDate,
  endDate,
  isSubmit,
}) => {
  const hasEndDate = endDate?.toDate().toLocaleDateString() ? true : false;

  return (
    <ResponsiveSearchDrawerItemContent
      role='button'
      tabIndex={-1}
      onClick={onClick}
      isError={isSubmit && !hasEndDate}
    >
      {!startDate ? (
        <EmptyComp label='Giriş' />
      ) : (
        <SelectedComponent
          value={formatDateForDateInput(startDate) || ''}
          label='Giriş'
          rightBorder
        />
      )}

      {!endDate ? (
        <EmptyComp label='Çıkış' />
      ) : (
        <SelectedComponent
          value={formatDateForDateInput(endDate) || ''}
          label='Çıkış'
          rightBorder
        />
      )}
    </ResponsiveSearchDrawerItemContent>
  );
};

export default HotelResponsiveSearchDrawerItem;
